import useStyles from './styles'

const getCount = (status: TaskStatus, taskStats: GlobalTaskStats) => {
  if (!taskStats) {
    return 0
  }

  const { statuses } = taskStats
  const count = statuses.find(s => s.id === status.id)?.value
  return count ?? 0
}

export const getStatusObj = (
  status: TaskStatus,
  classes: ReturnType<typeof useStyles>,
  stats: GlobalTaskStats
) => {
  const count = getCount(status, stats)

  const dispName = (
    <div className={classes.name}>
      {status.name} <div>({count})</div>
    </div>
  )

  return {
    ...status,
    dispName,
    count
  }
}
